/**
 * Storage that never throws: private windows and locked-down browsers can
 * refuse access, and nothing here is worth crashing over.
 */
function safe(kind: 'local' | 'session'): Storage | null {
  try {
    return kind === 'local' ? window.localStorage : window.sessionStorage;
  } catch {
    return null;
  }
}

export const store = {
  get(key: string, kind: 'local' | 'session' = 'local'): string | null {
    try {
      return safe(kind)?.getItem(key) ?? null;
    } catch {
      return null;
    }
  },
  set(key: string, value: string, kind: 'local' | 'session' = 'local'): void {
    try {
      safe(kind)?.setItem(key, value);
    } catch {
      /* ignore */
    }
  },
  remove(key: string, kind: 'local' | 'session' = 'local'): void {
    try {
      safe(kind)?.removeItem(key);
    } catch {
      /* ignore */
    }
  },
};

export const KEYS = {
  theme: 'ch:theme',
  lastOrg: 'ch:last-org',
  pendingInvite: 'ch:pending-invite',
  returnTo: 'ch:return-to',
  pendingAttest: 'ch:pending-attest',
  sidebar: 'ch:sidebar',
  chunkReload: 'ch:chunk-reload',
} as const;
